module.exports = __webpack_public_path__ + "media/images/lb/939-b8375d11402a2953ea76480e2c28461c.svg";